import { useTranslator } from '@/hooks'
import { Button, DialogContent, Typography, Drawer, Box, DialogTitle, Divider } from '@mui/material'
import { CreateUserForm } from './CreateUserForm'

export function CreateLiftUserDrawer({ open, setOpen, onSuccess }: any) {
  const { __ } = useTranslator()

  const handleClose = () => {
    setOpen(false)
  }

  return (
    <Drawer
      open={open}
      onClose={handleClose}
      closeAfterTransition={false}
      anchor='right'
      variant='temporary'
      sx={{
        '& .MuiDrawer-paper': {
          width: {
            xs: 370,
            sm: 370,
            md: 370
          }
        }
      }}
    >
      <DialogTitle className='flex justify-between items-center p-4'>
        <Typography className='text-[18px] leading-[28px] font-medium'>{__('Add New User')}</Typography>
        <Button className='w-6 h-6' onClick={handleClose} variant='text' color='inherit'>
          <i className='tabler-x w-6 h-6' />
        </Button>
      </DialogTitle>
      <Divider />
      <DialogContent className='p-6'>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
          <CreateUserForm onClose={handleClose} refetch={onSuccess} />
        </Box>
      </DialogContent>
    </Drawer>
  )
}
